import React , {  useState } from "react";
import { useTranslation } from "react-i18next";
import { Alert, Card, CardContent, Grid, RadioGroup, TextField, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Link } from "@deere/fuel-react";
import "../../assets/css/Sections.css";
import "../../assets/css/TpsStyles.css";
import FuelTable from "../../components/FuelTable";
import LinearProgressIndicator from "../../components/LineProgressIndicator";
import { SuppliersTable } from "../../components/supplier-table/SuppliersTable";
import { EMP_DEC, EMP_REQ, EMPTY_BODY, EWDC, SURVEYPART_SECTION_TYPES } from "../../utils/surveyLiterals";
import { getLDTranslation, getTranslation, getRequestStatusWhenCampaignClosed, findAnswerIndex } from "../../utils/utils";
import { showTablesError } from "../../utils/validation";
import QuestionsComponent from "../../components/QuestionsComponent";
import { PartsTable } from "../../components/part-table/PartsTable";
import PartsTableReview from "../../components/part-table/PartsTableReview";
import { ReactComponent as HelpIcon } from "@deere/ux.brand-foundations/icons/help.svg";
import { ModalDocument } from "../../components/modals/ModalDocument";
import AttachmentSection from "../../components/attachment-section/AttachmentSection";
import AttachmentSectionReview from "../../components/attachment-section/AttachmentSectionReview";

export default function SectionPage({
  surveyData,
  section,
  survey,
  campaign,
  surveyPartResponses,
  isSubmit,
  setIsSubmitted,
  resetForm,
  opcSelected,
  pushResponseName,
  updatePartsArray,
  updateSuppliersArray,
  selectionModel,
  setSelectionModel,
  review,
  questionsToValidate,
  pushAnswer,
  popAnswer,
  transactionParts,
  setTransactionParts,
  partErrorIds,
  setPartErrorIds,
  url,
  isAuthMethodOkta,
  token,
  literals,
  saveButtonClickFlag,
  setSaveButtonClickFlag,
  uploadedFiles,
  setUploadedFiles
}) {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const headers = survey.code === EWDC ? [
    "",
      t("lbl_response_section_column_name"),
      EMP_REQ,
      EMP_DEC,
      t("lbl_response_section_column_date"),
      t("lbl_response_section_column_updated_by"),
      t("lbl_response_section_column_status"),
    "",
  ]
  :
  [
    "",
    t("lbl_response_section_column_name"),
    t("lbl_response_section_column_parts_req"),
    t("lbl_response_section_column_parts_dec"),
    t("lbl_response_section_column_date"),
    t("lbl_response_section_column_updated_by"),
    t("lbl_response_section_column_status"),
    "",
  ];
  const questions = section.questions.filter((qu) => qu.active).sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1));
  const answers = Array.isArray(surveyData?.answers) ? surveyData.answers : [];
  const suppliersTable = Array.isArray(surveyData?.suppliers) ? surveyData.suppliers : [];
  const partsData = Array.isArray(surveyData?.partAnswers) ? surveyData.partAnswers : [];
  const responseName = surveyData?.responseName ? surveyData.responseName : "";
  const [dependentQuestions, setDependentQuestions] = useState([]);
  const partSections = survey?.sections?.filter((sec) => sec.type === SURVEYPART_SECTION_TYPES.PART);
  const multiplePartSections = partSections && partSections.length > 1 ? true : false;

  if (!section) return EMPTY_BODY;

  function createInputName() {
    const required = review ? false : true;
    const name = responseName ? responseName : null;
    let isError = typeof isSubmit === "boolean" && isSubmit ? !responseName && responseName.length <= 0 : false;
    return (
      <>
        {review ? (
          <>
            <Typography size="sm" component="p" gutterBottom key={`lbl-${t("coo_lbl_survey_response_name")}`} fontWeight="semibold">
              {t("coo_lbl_survey_response_name")}
            </Typography>
            <Typography size="sm" component="p" gutterBottom key={t("coo_lbl_survey_response_name")}>
              {name ? name : ""}
            </Typography>
          </>
        ) : (
          <>
            <TextField
              required={required}
              onChange={(e) => pushResponseName(e.target.value)}
              value={name ? name : ""}
              name={`${getTranslation(section, "description")}-`}
              error={isError}
              variant="outlined"
              helperText={isError ? t("bs_required") : ""}
              label={t("coo_lbl_survey_response_name")}
              key={t("coo_lbl_survey_response_name")}
              sx={{ "& .MuiFormLabel-root": { fontSize: "12px" } }}
            />
          </>
        )}
      </>
    );
  }

  function renderParts() {
    let isError = typeof isSubmit === "boolean" && isSubmit ? showTablesError(suppliersTable, partsData, true) : false;
    return review ? (
      <Grid item md={12}>
        <PartsTableReview questions={questions} surveyData={surveyData} campaign={campaign} multiplePartSections={multiplePartSections} sectionCode={section.code} code={survey.code} defaultColumns={survey.defaultColumns}/>
      </Grid>
    ) : (
      <>
        <Grid item xs={6} md={12}>
          <PartsTable
            dependentQuestions={dependentQuestions}
            setDependentQuestions={setDependentQuestions}
            campaign={campaign}
            suppliers={surveyData.suppliers}
            updatePartsArray={updatePartsArray}
            selectedResponseId={surveyData.responseId}
            selectionModel={selectionModel}
            setSelectionModel={setSelectionModel}
            transactionParts={transactionParts}
            setTransactionParts={setTransactionParts}
            questions={questions}
            partErrorIds={partErrorIds}
            setPartErrorIds={setPartErrorIds}
            isAuthMethodOkta={isAuthMethodOkta}
            token={token}
            literals={literals}
            code={survey.code}
            saveButtonClickFlag={saveButtonClickFlag}
            setSaveButtonClickFlag={setSaveButtonClickFlag}
            multiplePartSections={multiplePartSections}
            sectionCode={section.code}
            defaultColumns={survey.defaultColumns}
            assignments={surveyData.assignments}
          />
        </Grid>
        <Grid item xs={6} md={12}>
          {isError ? <Alert variant={"error"}> {t("bs_required")}</Alert> : null}
        </Grid>
      </>
    );
  }

  function renderSupplier() {
    let isError = typeof isSubmit === "boolean" && isSubmit ? showTablesError(suppliersTable, partsData, false) : false;
    const tmpAssignments = review && surveyData ? surveyData.assignments : null;
    return review ? (
      <>
        <Grid item xs={6} md={4} sx={{ paddingBottom: "12px", paddingLeft: "10px" }}>
          {createInputName()}
        </Grid>
        <Grid item md={12}>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>{t("cm_lbl_supplier")}</TableCell>
                  <TableCell>{t("t2_supplier_name")}</TableCell>
                  <TableCell>{t("lbl_Request_Number")}</TableCell>
                  <TableCell>{t("lbl_response_section_column_status")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tmpAssignments
                  ? tmpAssignments.map((row) => (
                      <TableRow key={`rp-${row.id}`}>
                        <TableCell align="left">{row.supplierNumber}</TableCell>
                        <TableCell align="left">{row.supplierName}</TableCell>
                        <TableCell align="left">{row.id}</TableCell>
                        <TableCell align="left">{campaign ? getRequestStatusWhenCampaignClosed(row.status, campaign.status) : ""}</TableCell>
                      </TableRow>
                    ))
                  : ""}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </>
    ) : (
      <>
        <Grid item xs={6} md={4} sx={{ paddingBottom: "12px", paddingLeft: "10px" }}>
          {createInputName()}
        </Grid>
        <Grid item xs={6} md={12}>
          <SuppliersTable campaign={campaign} assignments={surveyData.assignments} updateSuppliersArray={updateSuppliersArray} isAuthMethodOkta={isAuthMethodOkta} token={token} />
        </Grid>
        <Grid item xs={6} md={12}>
          {isError ? <Alert variant={"error"}> {t("bs_required")}</Alert> : null}
        </Grid>
      </>
    );
  }

  function renderResponseSection() {
    if (surveyPartResponses) {
      return (
        <Grid item xs={8} md={12}>
          <RadioGroup name="selectedCustom" value={opcSelected}>
            <FuelTable headers={headers} data={surveyPartResponses ? surveyPartResponses : []} resetForm={resetForm} sx={{ tableCellStyle: { fontSize: "12px!important" } }} />
          </RadioGroup>
        </Grid>
      );
    } else {
      return (
        <Grid item xs={6} md={12}>
          <LinearProgressIndicator title="Loading responses" subtitle="This will take a couple of seconds" />
        </Grid>
      );
    }
  }

  const renderQuestionsComponent = () => {
    return (
      <QuestionsComponent
        survey={survey}
        questions={questions}
        answers={answers}
        isSubmit={isSubmit}
        setIsSubmitted={setIsSubmitted}
        pushAnswer={pushAnswer}
        popAnswer={popAnswer}
        review={review}
        section={section}
        questionsToValidate={questionsToValidate}
        setUploadedFiles={setUploadedFiles}
        uploadedFiles={uploadedFiles}
        campaign={campaign}
      />
    );
  }

  const renderAttachmentsSection = () => {
    return review ? (
      <AttachmentSectionReview surveyCode={survey.code} assignmentId={campaign.assignments[0].id} token={token} isAuthMethodOkta={isAuthMethodOkta} />
    ) : (
      <AttachmentSection surveyCode={survey.code} assignmentId={campaign.assignments[0].id} token={token} isAuthMethodOkta={isAuthMethodOkta} />
    );
  };

  const renderAdminComments =() => {
    let que=section?.questions[0];
    let queId = que && que.id ? que.id : null;
    let index=findAnswerIndex(queId, answers)
    let adminAnswer= answers[index]?.answer;
    return review ?(
      <>
          <div>{adminAnswer}</div>
      </>
    ):null
  }

  function shouldDisplay(section) {
    if (section.active){
      if (SURVEYPART_SECTION_TYPES.RESPONSES !== section.type) {
        return true;
      }
      if (Array.isArray(surveyPartResponses) && surveyPartResponses.length > 0) {
        return true;
      } else {
        return false;
      }
    }else {
      return false;
    }
    
  }

  function renderSection(section) {
    if (section.type ) {
      switch (section.type) {
        case SURVEYPART_SECTION_TYPES.RESPONSES:
          return renderResponseSection();
        case SURVEYPART_SECTION_TYPES.QUESTIONS:
          return renderQuestionsComponent();
        case SURVEYPART_SECTION_TYPES.SUPPLIER:
          return renderSupplier();
        case SURVEYPART_SECTION_TYPES.PART:
          return renderParts();
        case SURVEYPART_SECTION_TYPES.ADMIN_COMMENTS:
          return renderAdminComments();
        default:
          return null;
      }
    }
  }

  return shouldDisplay(section) ? (
    <>
      <Card>
        <CardContent id={section ? section.description : ""}>
          <Grid mb={5}>
            <Typography gutterBottom variant="h4">
              {getTranslation(section, "description")}
              {section.type === SURVEYPART_SECTION_TYPES.PART && <HelpIcon onClick={() => setShowModal(true)}> </HelpIcon>}
            </Typography>
            <Typography gutterBottom variant="subtitle1">
              {getLDTranslation(section, "longDescription")}
            </Typography>
            {section.links &&
              section.links.map((link) => (
                <Typography size="sm" component="p" variant="h3">
                  <Link href={link.url} target="_blank">
                    {getTranslation(link, "text")}
                  </Link>
                </Typography>
              ))}
          </Grid>
          <Grid container>{renderSection(section)}</Grid>
        </CardContent>
      </Card>
      <br />
      <ModalDocument 
          showModal={showModal}
          setShowModal={setShowModal}
          labelBtnPrimary={t("btn_close")}
          titleModal={t("lbl_Help_Doc")}
          iFrameUrl={url}
      />
    </>
  ) : (
    ""
  );
}
